import { MinusOutlined } from "@ant-design/icons";
import { Button, Drawer, InputNumber, Select } from "antd";
import CustomList from "app/components/CustomList";
import DropDown from "app/components/DropDown";
import { EInventoryBuildingClass, EInventoryRentalArea, EInventoryLabel, EInventorySpaceType } from "constant";
import { IGetInventoryInputModel } from "interfaces/inventory/api";
import { TDistrictOutputModel, TProvinceOutputModel } from "interfaces/province";
import { useTranslation } from "react-i18next";

type P_Props = {
  visible: boolean;
  filter: Partial<IGetInventoryInputModel>;
  options: {
    provinces: TProvinceOutputModel[];
    districts: TDistrictOutputModel[];
  };
  onClose: () => void;
  onApply: () => void;
  onChangeValue: (data: Partial<IGetInventoryInputModel>) => void;
};

const InventoryFilterPresenter = (props: P_Props) => {
  const { t } = useTranslation("translation");

  return (
    <>
      <Drawer
        title="Bộ lọc"
        className="filter-drawer"
        placement="right"
        onClose={props.onClose}
        open={props.visible}
        footer={
          <div className="pt_1 pb_1 d-flex items-center justify-space-between" onClick={props.onClose}>
            <Button size="large" className="w_45">
              <span>Huỷ bỏ</span>
            </Button>
            <Button size="large" className="btn w_45" onClick={props.onApply}>
              <span>Áp dụng</span>
            </Button>
          </div>
        }
      >
        <div className="filter-drawer__inner">
          <div className="filter-menu">
            <DropDown
              title={"Thành Phố"}
              rightSideIcons={[]}
              render={() => (
                <Select
                  allowClear
                  placeholder="Chọn thành phố"
                  onChange={(value) => {
                    props.onChangeValue({ provinceCode: value });
                  }}
                  className="mr_1 w_100"
                  options={props.options.provinces.map((province) => ({ value: province.code, label: province.name }))}
                  size="large"
                  maxTagCount="responsive"
                  value={props.filter.provinceCode}
                />
              )}
            />

            <DropDown
              title={"Quận"}
              rightSideIcons={[]}
              render={() => (
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Chọn theo quận"
                  onChange={(value) => {
                    props.onChangeValue({ districtCodes: value });
                  }}
                  className="mr_1 w_100"
                  options={props.options.districts.map((district) => ({ value: district.code, label: district.name }))}
                  size="large"
                  maxTagCount="responsive"
                  value={props.filter.districtCodes}
                  defaultValue={props.filter.districtCodes}
                />
              )}
            />

            <DropDown
              title={"Trạng thái"}
              rightSideIcons={[]}
              render={() => (
                <>
                  <Select
                    allowClear
                    placeholder="Chọn trạng thái"
                    onChange={(value) => {
                      props.onChangeValue({ isShow: value });
                    }}
                    className="mr_1 w_100"
                    options={[
                      {
                        value: true,
                        label: "Hiển thị",
                      },
                      {
                        value: false,
                        label: "Ẩn",
                      },
                    ]}
                    size="large"
                    maxTagCount="responsive"
                    value={props.filter.isShow}
                    defaultValue={props.filter.isShow}
                  />
                </>
              )}
            />

            <DropDown
              title={"Thẻ tiêu đề"}
              rightSideIcons={[]}
              render={() => (
                <>
                  <CustomList
                    list={(Object.keys(EInventoryLabel) || [])?.map((i) => ({
                      id: i,
                      label: (EInventoryLabel as any)[i],
                    }))}
                    value={props.filter.labels}
                    onChange={(value) => {
                      props.onChangeValue({ labels: value });
                    }}
                    renderWith={"checkbox"}
                    renderLabel={(data) => t(data.label.toUpperCase())}
                  />
                </>
              )}
            />

            <DropDown
              title={"Hạng toà nhà"}
              rightSideIcons={[]}
              render={() => (
                <>
                  <CustomList
                    list={(Object.keys(EInventoryBuildingClass) || [])?.map((i) => ({
                      id: i,
                      label: (EInventoryBuildingClass as any)[i],
                    }))}
                    value={props.filter.buildingClasses}
                    onChange={(value) => {
                      props.onChangeValue({ buildingClasses: value });
                    }}
                    renderWith={"checkbox"}
                    renderLabel={(data) => t(data.label.toUpperCase())}
                  />
                </>
              )}
            />

            <DropDown
              title={"Loại hình không gian"}
              rightSideIcons={[]}
              render={() => (
                <>
                  <CustomList
                    list={(Object.keys(EInventorySpaceType) || [])?.map((i) => ({
                      id: i,
                      label: (EInventorySpaceType as any)[i],
                    }))}
                    value={props.filter.spaceTypes}
                    onChange={(value) => {
                      props.onChangeValue({ spaceTypes: value });
                    }}
                    renderWith={"checkbox"}
                    renderLabel={(data) => t(data.label.toUpperCase())}
                  />
                </>
              )}
            />

            <DropDown
              title={"Diện tích cho thuê"}
              rightSideIcons={[]}
              render={() => (
                <>
                  <CustomList
                    list={(Object.keys(EInventoryRentalArea) || [])?.map((i) => ({
                      id: i,
                      label: (EInventoryRentalArea as any)[i],
                    }))}
                    value={props.filter.rentalAreas}
                    onChange={(value) => {
                      props.onChangeValue({ rentalAreas: value });
                    }}
                    renderWith={"checkbox"}
                    renderLabel={(data) => data.label}
                  />
                </>
              )}
            />

            <DropDown
              title={"Khoảng giá"}
              rightSideIcons={[]}
              render={() => (
                <div className="d-flex items-center justify-space-between">
                  <InputNumber
                    min={1}
                    max={100}
                    defaultValue={props.filter.priceFrom}
                    size="large"
                    className="w_40"
                    onChange={(number) => {
                      props.onChangeValue({ priceFrom: number || 0 });
                    }}
                  />
                  <MinusOutlined />
                  <InputNumber
                    min={1}
                    max={100}
                    defaultValue={props.filter.priceTo}
                    size="large"
                    className="w_40"
                    onChange={(number) => {
                      props.onChangeValue({ priceTo: number || 0 });
                    }}
                  />
                </div>
              )}
            />
          </div>
        </div>
      </Drawer>
    </>
  );
};

export default InventoryFilterPresenter;
